import { ParameterType } from '@/study-search/enums';
import { TitleBase } from './TitleBase';

export default class TitleAttendanceCountry extends TitleBase {
	private countryValue: string;
	private deliveryMethodValue: string;

	protected canHandle(): boolean {
		this.countryValue = this.getFilterValue(ParameterType.COUNTRY);
		this.deliveryMethodValue = this.getFilterValue(ParameterType.DELIVERY_METHOD);

		return (
			this.indexableFilters.length === 2 &&
			this.indexableFilters.some((_) => _.type === ParameterType.DELIVERY_METHOD) &&
			this.indexableFilters.some((_) => _.type === ParameterType.COUNTRY)
		);
	}

	protected getPageTitle(): string {
		return `${this.deliveryMethodValue} ${this.titlePortalType} offered by universities in ${this.countryValue}`;
	}

	protected getMetaTitle(): string {
		return (
			`Search ${this.totalSearchResults} ${this.deliveryMethodValue.toLowerCase()} ` + `${this.titlePortalType} in ${this.countryValue}`
		);
	}

	protected getMetaDescription(): string {
		return (
			`Study your master's ${this.deliveryMethodValue.toLowerCase()} from a university in ${this.countryValue} ` +
			`with one of the ${this.totalSearchResults} ${this.deliveryMethodValue.toLowerCase()} ` +
			`${this.titlePortalType.toLowerCase()} available to you with Mastersportal.`
		);
	}
}
